import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { EnactConfirmationBoxComponent } from './enact-confirmation-box.component';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MapChangeComponent } from '../map-change/map-change.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

@NgModule({
    declarations: [
        EnactConfirmationBoxComponent,
        MapChangeComponent
    ],
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        TranslateModule,
        MatFormFieldModule,
        MatSelectModule,
        MatFormFieldModule
    ],
    exports: [
        EnactConfirmationBoxComponent,
        MapChangeComponent
    ]
})
export class EnactConfirmationBoxModule { }